import React from 'react'
import DSIcon from './DSIcon'

const SelectInput = ({ name = '', label = '', value = '', placeholder = '', icon ,  inputClasses = '', selectList = [], handler, labelClasses = '', classes = '', iconPosition = '96%', disable = false, inputBackColor = '#F9FAFB' }) => {
  labelClasses = labelClasses || 'text-2xs uppercase tracking-widest text-gray-600 font-semibold'

  return (
    <div className={classes + ' relative'}>
      {label && <span className={'block mb-2 ' + labelClasses}>{label}</span>}
      <select
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={handler}
        disabled={disable}
        className={`h-11 w-full appearance-none rounded-ds-md border border-gray-275 px-4 pr-10 text-xs font-medium text-gray-900 transition-colors duration-150 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 ${inputClasses}`}
        style={{ backgroundColor: inputBackColor }}
      >
        {selectList.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          )
        })}
      </select>
      <span className='pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500'>
        {icon ? <img src={icon} alt='select-icon' className='h-3 w-3' /> : <DSIcon name='chevron-down' size={16} />}
      </span>
    </div>
  )
}

export default SelectInput
